import React from 'react'
import { useTypedSelector } from '../../Hooks/useTypedSelector'
import { useDispatch, useSelector } from 'react-redux'
import { toggleInputActive } from '../../Actions/QuickSearch.action';
import { translate } from '../../Services/translation';
import { RootState } from '../../reducers';
import { toggleMobileMenu } from '../../Actions/Navigation.action';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import Icon from '../Icon';
import MobileFooterMenuIconWrapper from './MobileFooterMenuIconWrapper';
import IconText from './IconText';
import { setLoginModalOpen } from '../../Actions/Login.action';
import { setShowMiniCart } from '../../Actions/Cart.action';

const StyledQuickSearchIcon = styled(Icon) <{ $inputActive: boolean }>`
  cursor: pointer;
  color: ${(props) => (props.$inputActive ? getColor('white') : getColor('grey', 900))};
`;

export default function QuickSearchLinkMobile() {
    const quickSearch = useTypedSelector((state) => state.quickSearch);
    const dispatch = useDispatch();
    const mobileMenuOpen = useSelector((state: RootState) => state.navigation.mobileMenuOpen);

    return (
        <MobileFooterMenuIconWrapper
            aria-label={translate('general.search-word')}
            onClick={() => {

                dispatch(toggleInputActive(!quickSearch.inputActive, quickSearch.inputActive))
                if (mobileMenuOpen) {
                    dispatch(toggleMobileMenu(!mobileMenuOpen))
                }
                dispatch(setLoginModalOpen(false))
                dispatch(setShowMiniCart(false))
            }}>
            <StyledQuickSearchIcon
                name={quickSearch.inputActive ? 'close-nav' : 'magnifier'}


                $inputActive={quickSearch.inputActive}
                className="icon--larger"
            />
            <IconText translationKey="general.search-word" />
        </MobileFooterMenuIconWrapper>
    )
}
